import * as React from 'react';
import styles from './StemPage.css';
import { Title } from '../title';
import { ClickElement } from '../form';
import { 
  AutoSuggestSearch,
  AutoSuggestItem,
} from '../search';
import { STEMFORM } from '../../lib/labels';

export const StemForm = ({ 
  videoList, 
  onSelect, 
  onRemove, 
  onSubmit,
  isLoading,
  inputRef,
  error,
}) => (
  <>
    <Title Tag='h2'>
      {STEMFORM.TITLE}
    </Title>
    <p>
      {STEMFORM.DESCRIPTION}
    </p>
    <ul>
      {STEMFORM.SUMUP.map((item) => <li key={item}>{item}</li>)}
    </ul>

    {(videoList.length > 0) && (
      <>
        <div className={styles.selected_videos}>
          <h3>{STEMFORM.SELECTED_VIDEOS}</h3>
          {videoList.map((item, index) => (
            <AutoSuggestItem
              key={`selectedItem-${index}`}
              item={item}
              onRemove={onRemove}
              index={index}
              selected
            />
          ))}
          {(videoList.length > 4) && (
            <>
              <p>
                {STEMFORM.MIN_VIDEOS_TEXT}
                {(10 - videoList.length !== 0)
                  ? STEMFORM.ADD_VIDEOS_TEXT.replace('{length}', 10 - videoList.length)
                  : STEMFORM.MAX_VIDEOS_TEXT }
              </p>
              {error !== null && (
                <p className={styles.error}>{error}</p>
              )}
              {isLoading && (
                <p>{STEMFORM.LOADING_TEXT}</p>
              )}                
              <ClickElement
                ElementType="button"
                text={STEMFORM.BUTTON}
                onClick={onSubmit}
                primary
              />
            </>
          )}
        </div>
      </>
    )}
    {(videoList.length >= 0 && videoList.length < 10) && (
      <AutoSuggestSearch onSelect={onSelect} inputRef={inputRef} />
    )}
  </>
);